import { render, staticRenderFns } from "./AK3Icon.vue?vue&type=template&id=6f518a17&scoped=true&"
import script from "./AK3Icon.vue?vue&type=script&lang=js&"
export * from "./AK3Icon.vue?vue&type=script&lang=js&"
import style0 from "./AK3Icon.vue?vue&type=style&index=0&id=6f518a17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f518a17",
  null
  
)

export default component.exports